// directives/cached-img.directive.ts
import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ImageCacheService } from '../service/image-cache.service';


@Directive({
  selector: 'img[cachedSrc]',
  standalone: true
})
export class CachedImgDirective implements OnChanges {
  @Input() cachedSrc!: string;
  private currentObjectUrl: string | null = null;

  constructor(
    private el: ElementRef<HTMLImageElement>,
    private imageCache: ImageCacheService
  ) {}

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes['cachedSrc'] && this.cachedSrc) {
      // Pulisce l'URL blob precedente per liberare memoria
      if (this.currentObjectUrl) {
        URL.revokeObjectURL(this.currentObjectUrl);
      }

      try {
        const objectUrl = await this.imageCache.getImageBlobUrl(this.cachedSrc);
        this.currentObjectUrl = objectUrl;
        this.el.nativeElement.src = objectUrl;
      } catch {
        this.el.nativeElement.src = this.cachedSrc;
      }
    }
  }
}